module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/testimonial/testimonial-style1/testimonial-style1.component.scss
// module id = ./src/app/features/testimonial/testimonial-style1/testimonial-style1.component.scss
// module chunks = main